<template>
  <div>
    <mallHeader />
    <router-view :key="$route.fullPath" />
    <mallFooter />
  </div>
</template>

<script>
import mallHeader from '@/components/mallHeader';
import mallFooter from '@/components/mallFooter';
export default {
  components: { mallHeader, mallFooter },
};
</script>

<style></style>
